/**
 * @generated SignedSource<<872c6cfbc53b11182d09a65046657a3e>>
 * @relayHash 7e12a696ad0d6a7fca78aef0290e496d
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 7e12a696ad0d6a7fca78aef0290e496d

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contractId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "contractId",
        "variableName": "contractId"
      }
    ],
    "concreteType": "ReopenContractMutationResponse",
    "kind": "LinkedField",
    "name": "closeAndDuplicateContract",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "newContractId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CloseAndDuplicateContractMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CloseAndDuplicateContractMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "7e12a696ad0d6a7fca78aef0290e496d",
    "metadata": {},
    "name": "CloseAndDuplicateContractMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "5b2bf6f809e386bfc8671522742498a4";

export default node;
